// FETCH ALL PROPERTIES FROM BRAND_MASTER PAGE
export const FETCH_BRAND_MASTER_REQUEST = 'FETCH_BRAND_MASTER_REQUEST';
export const FETCH_BRAND_MASTER_SUCCESS = 'FETCH_BRAND_MASTER_SUCCESS';
export const FETCH_BRAND_MASTER_FAILURE = 'FETCH_BRAND_MASTER_FAILURE';

export const FETCH_BUYER_NAME_MASTER_REQUEST = 'FETCH_BUYER_NAME_MASTER_REQUEST';
export const FETCH_BUYER_NAME_MASTER_SUCCESS = 'FETCH_BUYER_NAME_MASTER_SUCCESS';
export const FETCH_BUYER_NAME_MASTER_FAILURE = 'FETCH_BUYER_NAME_MASTER_FAILURE';

// CREATE PROPERTIES FOR BRAND_MASTER PAGE
export const CREATE_BRAND_MASTER_REQUEST = 'CREATE_BRAND_MASTER_REQUEST';
export const CREATE_BRAND_MASTER_SUCCESS = 'CREATE_BRAND_MASTER_SUCCESS';
export const CREATE_BRAND_MASTER_FAILURE = 'CREATE_BRAND_MASTER_FAILURE';

// UPDATE PROPERTIES FOR BRAND_MASTER PAGE
export const UPDATE_BRAND_MASTER_REQUEST = 'UPDATE_BRAND_MASTER_REQUEST';
export const UPDATE_BRAND_MASTER_SUCCESS = 'UPDATE_BRAND_MASTER_SUCCESS';
export const UPDATE_BRAND_MASTER_FAILURE = 'UPDATE_BRAND_MASTER_FAILURE';

// FETCH SINGLE PROPERTY FOR BRAND_MASTER PAGE
export const FETCH_SINGLE_BRAND_MASTER_REQUEST = 'FETCH_SINGLE_BRAND_MASTER_REQUEST';
export const FETCH_SINGLE_BRAND_MASTER_SUCCESS = 'FETCH_SINGLE_BRAND_MASTER_SUCCESS';
export const FETCH_SINGLE_BRAND_MASTER_FAILURE = 'FETCH_SINGLE_BRAND_MASTER_FAILURE';

// DELETE PROPERTIES FOR BRAND_MASTER PAGE
export const DELETE_BRAND_MASTER_REQUEST = 'DELETE_BRAND_MASTER_REQUEST';
export const DELETE_BRAND_MASTER_SUCCESS = 'DELETE_BRAND_MASTER_SUCCESS';
export const DELETE_BRAND_MASTER_FAILURE = 'DELETE_BRAND_MASTER_FAILURE';

export const CREATE_USER_FORM_BRAND_MASTER = 'CREATE_USER_FORM_BRAND_MASTER';
export const BRAND_MASTER_USERFORM_RESET = 'BRAND_MASTER_USERFORM_RESET';
